import React from 'react';
import { Link } from 'react-router-dom';
import NewsletterForm from '../NewsletterForm';
import { useTranslation } from 'react-i18next';

export default function Newsletter({ title, subTitle }) {
  const { t } = useTranslation();
  return (
    <div className="cs_newsletter cs_style_1">
      <h2 className="cs_newsletter_title">{title}</h2>
      <div className="cs_newsletter_subTitle">
        {subTitle}
        <Link
          to="/connexion"
          style={{
            marginLeft: 6,
            color: 'inherit',
            textDecoration: 'underline',
            opacity: 0.7,
          }}
        >
          {t('footer.newsletter.loginLink')}
        </Link>
      </div>
      <NewsletterForm
        placeholder={t('footer.newsletter.placeholder')}
        btnText={t('footer.newsletter.button')}
        btnArrowUrl="/images/icons/arrow_white.svg"
      />
    </div>
  );
}
